import {
	Avatar,
	Button,
	Card,
	Combobox,
	createTheme,
	Drawer,
	Input,
	LoadingOverlay,
	Modal,
	MultiSelect,
	NumberFormatter,
	Select,
} from "@mantine/core";
import { DateInput } from "@mantine/dates";
import buttonClasses from "./Button.module.css";
import multiSelectClasses from "./MultiSelect.module.css";

export const theme = createTheme({
	fontFamily: "Be Vietnam Pro, sans-serif",
	autoContrast: true,
	components: {
		Modal: Modal.extend({
			defaultProps: {
				closeOnClickOutside: false,
				zIndex: 200,
			},
		}),
		ComboBox: Combobox.extend({
			defaultProps: {
				zIndex: 1_000_000,
			},
		}),
		Drawer: Drawer.extend({
			defaultProps: {
				closeOnClickOutside: false,
				position: "right",
				zIndex: 300,
			},
		}),
		NumberFormatter: NumberFormatter.extend({
			defaultProps: {
				decimalSeparator: ",",
				thousandSeparator: " ",
			},
		}),
		Card: Card.extend({
			defaultProps: {
				withBorder: true,
				radius: "md",
			},
		}),
		DateInput: DateInput.extend({
			defaultProps: {
				valueFormat: "YYYY-MM-DD",
			},
		}),
		Button: Button.extend({
			classNames: buttonClasses,
			defaultProps: {
				variant: "light",
			},
		}),
		LoadingOverlay: LoadingOverlay.extend({
			defaultProps: {
				zIndex: 400,
			},
		}),
		Input: Input.extend({
			defaultProps: {
				variant: "filled",
			},
		}),
		Select: Select.extend({
			defaultProps: {
				allowDeselect: false,
			},
		}),
		MultiSelect: MultiSelect.extend({
			classNames: multiSelectClasses,
			defaultProps: {
				hidePickedOptions: true,
			},
		}),
		Avatar: Avatar.extend({
			defaultProps: {
				color: "initials",
			},
		}),
	},
});
